export default "__VITE_ASSET__DLsoiIjN__"